(function(){
  var root = document.getElementById('wr-page');
  if(!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- SF store constants ---------- */
  var SF_TEL = '+18586661551';
  var SF_TEL_DISPLAY = '(858) 666-1551';
  var EMAIL = 'info@wilsonebikes.com';
  var STORE_NAME = 'San Francisco (360 11th St, SoMa)';

  /* Pacific-time clock helper */
  function ptParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone:'America/Los_Angeles', hour:'2-digit', minute:'2-digit', hour12:false, month:'numeric'
      }).formatToParts(new Date());
      var o = { hour:0, minute:0, month:7 };
      parts.forEach(function(p){
        if(p.type === 'hour') o.hour = parseInt(p.value, 10) % 24;
        if(p.type === 'minute') o.minute = parseInt(p.value, 10);
        if(p.type === 'month') o.month = parseInt(p.value, 10);
      });
      return o;
    } catch(e){
      var d = new Date();
      return { hour:d.getHours(), minute:d.getMinutes(), month:d.getMonth()+1 };
    }
  }
  // San Francisco: Mon-Sat 10AM-7PM PT, closed Sunday
  function sfHoursForMonth(){ return { open:600, close:1140 }; }
  function sfHoursToday(){ return { open:600, close:1140 }; }
  function ptWeekday(){
    try { return new Intl.DateTimeFormat('en-US',{ timeZone:'America/Los_Angeles', weekday:'short' }).format(new Date()); }
    catch(e){ return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][new Date().getDay()]; }
  }
  function isSundayPT(){ return ptWeekday() === 'Sun'; }
  function fmt12(mins){
    var h = Math.floor(mins/60), mm = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if(hh === 0) hh = 12;
    return hh + ':' + ('0'+mm).slice(-2) + ' ' + ap;
  }

  /* ---------- Ticket flow (4 steps, SF only) ---------- */
  var state = { ride:'', issue:'', date:'', dateLabel:'', time:'', store: STORE_NAME, tel: SF_TEL, telDisplay: SF_TEL_DISPLAY };
  var step = 1, TOTAL = 4;
  var panes = root.querySelectorAll('.wr-pane');
  var dots  = root.querySelectorAll('.wr-step-dot');
  var back  = document.getElementById('wr-back');
  var calGridEl = document.getElementById('wr-cal-grid');
  var calMonthEl = document.getElementById('wr-cal-month');
  var timeOptsWrap = document.getElementById('wr-time-opts');
  var dtContinueBtn = document.getElementById('wr-dt-continue');


  function show(n){
    step = n;
    panes.forEach(function(p){ p.hidden = (+p.dataset.pane !== n); });
    dots.forEach(function(dt){
      var s = +dt.dataset.step;
      dt.classList.toggle('wr-active', s === n);
      dt.classList.toggle('wr-done', s < n);
    });
    back.hidden = (n === 1);
    if(n === 3 && !state.date) initDateTimeStep();
    if(n === TOTAL) buildLinks();
  }

  function esc(s){ var t=document.createElement('span'); t.textContent=s||''; return t.innerHTML; }

  function buildLinks(){
    var nameEl = document.getElementById('wr-field-name');
    var phoneEl = document.getElementById('wr-field-phone');
    var descEl = document.getElementById('wr-field-desc');
    var name = nameEl ? nameEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';
    var desc = descEl ? descEl.value.trim() : '';
    var slotTxt = (state.dateLabel && state.time) ? (state.dateLabel + ' \u00b7 ' + state.time + ' PT') : (window.__wrNextSlotText || '');

    var msg = 'Hi Wilson\u2019s SF! I\u2019d like to book a repair at 360 11th St.\n'
      + 'Ride: ' + state.ride + '\n'
      + 'Issue(s): ' + state.issue + '\n'
      + (slotTxt ? 'Requested slot: ' + slotTxt + '\n' : '')
      + 'My name: ' + (name || '____') + '\n'
      + 'My phone: ' + (phone || '____')
      + (desc ? '\nDetails: ' + desc : '');

    document.getElementById('wr-summary').innerHTML =
      'RIDE ..... <b>' + esc(state.ride) + '</b><br>'
      + 'ISSUE(S) . <b>' + esc(state.issue) + '</b><br>'
      + 'STORE .... <b>San Francisco \u00b7 360 11th St, SoMa</b>'
      + (slotTxt ? '<br>SLOT ..... <b>' + esc(slotTxt) + '</b>' : '')
      + (name ? '<br>NAME ..... <b>' + esc(name) + '</b>' : '')
      + (phone ? '<br>PHONE .... <b>' + esc(phone) + '</b>' : '')
      + (desc ? '<br>DETAILS .. <b>' + esc(desc) + '</b>' : '');

    var ctaTextEl = document.getElementById('wr-cta-text');
    if(ctaTextEl){
      ctaTextEl.href = 'sms:' + SF_TEL + '?&body=' + encodeURIComponent(msg);
    }
    var ctaEmailEl = document.getElementById('wr-cta-email');
    if(ctaEmailEl){
      ctaEmailEl.href = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent('SF Repair Booking \u2014 ' + state.ride)
        + '&body=' + encodeURIComponent(msg);
    }
    var ctaCallEl = document.getElementById('wr-cta-call');
    if(ctaCallEl) ctaCallEl.href = 'tel:' + SF_TEL;
  }

  /* ---------- Confirm Booking: writes straight to the shop's Google Calendar ---------- */
  var BOOKING_ENDPOINT = "https://script.google.com/macros/s/AKfycby779T-3RrEgFYlNe6ERqyh9r67Ly4GFmeWLabXWf7-QRYV-6tZ3XPlsq_G7Z-rLV5Nsg/exec";
  var BOOKING_SHARED_SECRET = "7baa6fde45a3df7308c6ca288b3072da9b066182dcbc8370";

  function to24Hour(display){
    var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(display || '');
    if(!m) return '';
    var h = parseInt(m[1], 10);
    var min = m[2];
    var ampm = m[3].toUpperCase();
    if(ampm === 'PM' && h !== 12) h += 12;
    if(ampm === 'AM' && h === 12) h = 0;
    return (h < 10 ? '0' + h : h) + ':' + min;
  }

  function submitBookingToCalendar(){
    var btn = document.getElementById('wr-confirm-booking');
    var statusEl = document.getElementById('wr-confirm-status');
    if(!btn || !statusEl) return;

    if(!state.date || !state.time){
      statusEl.textContent = 'Pick a time slot above first.';
      statusEl.style.color = '#b45309';
      return;
    }

    var nameEl = document.getElementById('wr-field-name');
    var phoneEl = document.getElementById('wr-field-phone');
    var descEl = document.getElementById('wr-field-desc');
    var name = nameEl ? nameEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';

    if(!name){
      statusEl.textContent = 'Please enter your name so the team knows who\u2019s coming in.';
      statusEl.style.color = '#b91c1c';
      nameEl && nameEl.focus();
      return;
    }
    if(!/^\d{3}-\d{3}-\d{4}$/.test(phone)){
      statusEl.textContent = 'Please enter a valid US phone number (xxx-xxx-xxxx).';
      statusEl.style.color = '#b91c1c';
      phoneEl && phoneEl.focus();
      return;
    }

    var payload = {
      secret: BOOKING_SHARED_SECRET,
      shop: 'san-francisco',
      name: name,
      phone: phone,
      ride: state.ride || '',
      issue: state.issue || '',
      desc: descEl ? descEl.value.trim() : '',
      date: state.date,
      time: to24Hour(state.time),
    };

    btn.disabled = true;
    btn.textContent = 'Booking\u2026';
    statusEl.textContent = '';

    // text/plain avoids a CORS preflight against the Apps Script endpoint.
    fetch(BOOKING_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then(function(r){ return r.json(); })
      .then(function(result){
        if(result.ok){
          btn.textContent = 'Booked \u2713';
          statusEl.textContent =
            'You\u2019re on the schedule for ' + state.dateLabel + ' \u00b7 ' + state.time + ' PT. See you at 360 11th St, SoMa.';
          statusEl.style.color = '#3B5C54';
        } else {
          throw new Error(result.error || 'Unknown error');
        }
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = 'Book Your Repair Now';
        statusEl.textContent = 'Couldn\u2019t reach the shop\u2019s calendar \u2014 please call or text ' + SF_TEL_DISPLAY + ' instead.';
        statusEl.style.color = '#b91c1c';
      });
  }

  var confirmBookingBtn = document.getElementById('wr-confirm-booking');
  if(confirmBookingBtn) confirmBookingBtn.addEventListener('click', submitBookingToCalendar);

  root.addEventListener('input', function(e){
    var t = e.target;
    if(t && (t.id === 'wr-field-name' || t.id === 'wr-field-phone' || t.id === 'wr-field-desc')) buildLinks();
  });

  /* Phone field: digits only, auto-formatted as xxx-xxx-xxxx */
  var phoneFmtEl = document.getElementById('wr-field-phone');
  if(phoneFmtEl){
    phoneFmtEl.addEventListener('input', function(){
      var d = phoneFmtEl.value.replace(/\D/g, '').slice(0, 10);
      var out = d;
      if(d.length > 6) out = d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6);
      else if(d.length > 3) out = d.slice(0,3) + '-' + d.slice(3);
      phoneFmtEl.value = out;
    });
  }

  /* Name & phone are required before sending booking via Text */
  function requireContactFields(e){
    var nEl = document.getElementById('wr-field-name');
    var pEl = document.getElementById('wr-field-phone');
    if(!nEl || !nEl.value.trim()){
      e.preventDefault();
      alert('Please enter your name so the team knows who\u2019s coming in.');
      nEl && nEl.focus();
      return;
    }
    if(!pEl || !/^\d{3}-\d{3}-\d{4}$/.test(pEl.value.trim())){
      e.preventDefault();
      alert('Please enter a valid US phone number (xxx-xxx-xxxx).');
      pEl && pEl.focus();
    }
  }
  var ctaTextGate = document.getElementById('wr-cta-text');
  if(ctaTextGate) ctaTextGate.addEventListener('click', requireContactFields);
  var ctaEmailGate = document.getElementById('wr-cta-email');
  if(ctaEmailGate) ctaEmailGate.addEventListener('click', requireContactFields);

  /* Ride: single select, auto-advance */
  root.querySelectorAll('.wr-pane[data-pane="1"] .wr-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      var f = btn.dataset.field;
      state[f] = btn.dataset.value;
      btn.parentElement.querySelectorAll('.wr-opt').forEach(function(b){ b.classList.remove('wr-picked'); });
      btn.classList.add('wr-picked');
      setTimeout(function(){ if(step < TOTAL) show(step+1); }, 180);
    });
  });

  /* Issues: multi-select toggles + Continue */
  state.issues = [];
  var issuesContinue = document.getElementById('wr-issues-continue');
  function syncIssues(){
    state.issue = state.issues.join(', ');
    if(issuesContinue) issuesContinue.disabled = state.issues.length === 0;
  }
  root.querySelectorAll('.wr-pane[data-pane="2"] .wr-opt').forEach(function(btn){
    btn.setAttribute('aria-pressed', 'false');
    btn.addEventListener('click', function(){
      var val = btn.dataset.value;
      var idx = state.issues.indexOf(val);
      if(idx > -1){
        state.issues.splice(idx, 1);
        btn.classList.remove('wr-picked');
        btn.setAttribute('aria-pressed', 'false');
      } else {
        state.issues.push(val);
        btn.classList.add('wr-picked');
        btn.setAttribute('aria-pressed', 'true');
      }
      syncIssues();
    });
  });
  function syncContinueLabel(){
    if(issuesContinue) issuesContinue.textContent = state.issues.length ? ('Continue with ' + state.issues.length + ' selected \u2192') : 'Continue \u2192';
  }
  root.querySelectorAll('.wr-pane[data-pane="2"] .wr-opt').forEach(function(btn){ btn.addEventListener('click', syncContinueLabel); });
  if(issuesContinue){
    issuesContinue.addEventListener('click', function(){
      if(state.issues.length && step < TOTAL) show(step+1);
    });
  }
  back.addEventListener('click', function(){ if(step > 1) show(step-1); });
  show(1);

  /* ---------- Date & time step (full-month calendar, 15-min slots, respects store hours) ---------- */
  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DOW_NAMES = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function sfTodayParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone:'America/Los_Angeles', year:'numeric', month:'numeric', day:'numeric'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function(p){
        if(p.type === 'year') o.year = parseInt(p.value, 10);
        if(p.type === 'month') o.month = parseInt(p.value, 10);
        if(p.type === 'day') o.day = parseInt(p.value, 10);
      });
      return o;
    } catch(e){
      var d = new Date();
      return { year:d.getFullYear(), month:d.getMonth()+1, day:d.getDate() };
    }
  }
  var todaySF = sfTodayParts();

  function dateKeyFor(y, m, d){ return y + '-' + ('0'+m).slice(-2) + '-' + ('0'+d).slice(-2); }
  function parseDateKey(key){
    var p = key.split('-').map(Number);
    return { y:p[0], m:p[1], d:p[2] };
  }
  function formatDateLabel(key){
    var p = parseDateKey(key);
    var dt = new Date(p.y, p.m - 1, p.d);
    return DOW_NAMES[dt.getDay()] + ', ' + MONTH_NAMES[p.m - 1].slice(0,3) + ' ' + p.d;
  }

  function buildTimeSlots(dateKey){
    var p = parseDateKey(dateKey);
    if(new Date(p.y, p.m - 1, p.d).getDay() === 0) return []; // closed Sunday
    var h = sfHoursForMonth(p.m);
    var lastSlot = h.close - 60; // last bookable slot: 1 hour before close
    var isToday = (p.y === todaySF.year && p.m === todaySF.month && p.d === todaySF.day);
    var startMin;
    if(isToday){
      var pt = ptParts();
      var nowMins = pt.hour * 60 + pt.minute;
      startMin = Math.ceil((nowMins + 15) / 15) * 15; // next slot at least 15 min out, on the 15-min grid
      if(startMin < h.open) startMin = h.open;
    } else {
      startMin = h.open; // future day: first slot at opening
    }
    var slots = [];
    for(var t = startMin; t <= lastSlot; t += 15){ slots.push(t); }
    return slots;
  }

  function renderTimeSlots(){
    if(!timeOptsWrap) return;
    timeOptsWrap.innerHTML = '';
    dtContinueBtn.disabled = true;
    var slots = buildTimeSlots(state.date);
    if(!slots.length){
      timeOptsWrap.innerHTML = '<p class="wr-no-slots">No more slots on ' + esc(state.dateLabel) + '. Pick another day, or just walk in and we\u2019ll do our best to fit you in.</p>';
      return;
    }
    slots.forEach(function(mins){
      var label = fmt12(mins);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wr-opt wr-time-opt';
      b.dataset.field = 'time';
      b.dataset.value = label;
      b.textContent = label;
      b.addEventListener('click', function(){
        timeOptsWrap.querySelectorAll('.wr-opt').forEach(function(o){ o.classList.remove('wr-picked'); });
        b.classList.add('wr-picked');
        state.time = label;
        dtContinueBtn.disabled = false;
      });
      timeOptsWrap.appendChild(b);
    });
  }

  function selectDate(key, btnEl){
    state.date = key;
    state.dateLabel = formatDateLabel(key);
    state.time = '';
    if(calGridEl) calGridEl.querySelectorAll('.wr-cal-day').forEach(function(b){ b.classList.remove('wr-picked'); });
    if(btnEl) btnEl.classList.add('wr-picked');
    renderTimeSlots();
  }

  function buildCalendar(){
    if(!calGridEl) return;
    var y = todaySF.year, m = todaySF.month;
    var daysInMonth = new Date(y, m, 0).getDate();
    var firstWeekday = new Date(y, m - 1, 1).getDay();
    if(calMonthEl) calMonthEl.textContent = MONTH_NAMES[m - 1] + ' ' + y;
    calGridEl.innerHTML = '';
    for(var i = 0; i < firstWeekday; i++){
      var blank = document.createElement('span');
      blank.className = 'wr-cal-blank';
      calGridEl.appendChild(blank);
    }
    for(var day = 1; day <= daysInMonth; day++){
      var key = dateKeyFor(y, m, day);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wr-cal-day';
      btn.textContent = day;
      btn.dataset.value = key;
      var isPast = day < todaySF.day;
      var isToday = day === todaySF.day;
      var isSunday = new Date(y, m - 1, day).getDay() === 0;
      if(isToday) btn.classList.add('wr-cal-today');
      if(isPast || isSunday){
        btn.disabled = true;
        if(isSunday && !isPast) btn.title = 'Closed Sunday';
      } else if(isToday && buildTimeSlots(key).length === 0){
        btn.disabled = true;
      }
      btn.addEventListener('click', function(){
        if(this.disabled) return;
        selectDate(this.dataset.value, this);
      });
      calGridEl.appendChild(btn);
    }
  }

  function initDateTimeStep(){
    buildCalendar();
    var firstBtn = calGridEl ? calGridEl.querySelector('.wr-cal-day:not(:disabled)') : null;
    if(firstBtn) selectDate(firstBtn.dataset.value, firstBtn);
  }

  if(dtContinueBtn){
    dtContinueBtn.addEventListener('click', function(){
      if(!state.date || !state.time) return;
      if(step < TOTAL) show(step + 1);
    });
  }

  /* Location card "Book Repair Service" jumps to the ticket */
  var locBookBtn = document.getElementById('wr-loc-book-sf');
  if(locBookBtn){
    locBookBtn.addEventListener('click', function(){
      var bookSection = document.getElementById('book');
      var y = bookSection.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top:y, behavior: reduce ? 'auto' : 'smooth' });
      show(1);
    });
  }

  /* ---------- Smooth anchor scroll ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if(!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top:y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---------- Scroll-reveal ---------- */
  var revealTargets = root.querySelectorAll('.wr-price-card,.wr-svc,.wr-ride,.wr-loc,.wr-proc,.wr-why-card,.wr-rev,.wr-faq details,.wr-contact-card,.wr-gallery-grid img,.wr-live-card,.wr-final-opt,.wr-team-card,.wr-perk,.wr-story-step,.wr-map-card,.wr-gmb-btn');
  if(!reduce && 'IntersectionObserver' in window){
    revealTargets.forEach(function(el,i){
      el.classList.add('wr-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('wr-in'); io.unobserve(en.target); }
      });
    },{ threshold:.12 });
    revealTargets.forEach(function(el){ io.observe(el); });
  }

  /* ---------- Stat count-up ---------- */
  var counters = root.querySelectorAll('.wr-count');
  function runCount(el){
    var target = parseFloat(el.dataset.target), suffix = el.dataset.suffix || '';
    var dec = parseInt(el.dataset.decimals || '0', 10);
    if(reduce){ el.textContent = target.toFixed(dec) + suffix; return; }
    var start = null, DUR = 1200;
    function tick(ts){
      if(!start) start = ts;
      var p = Math.min((ts - start) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec) + suffix;
      if(p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ runCount(en.target); cio.unobserve(en.target); }
      });
    },{ threshold:.5 });
    counters.forEach(function(c){ cio.observe(c); });
  } else {
    counters.forEach(runCount);
  }

  var liveWxEl    = document.getElementById('wr-live-weather');

  function isStoreOpenNow(){
    if(isSundayPT()) return false;
    var h = sfHoursToday();
    var mins = ptParts().hour * 60 + ptParts().minute;
    return mins >= h.open && mins < h.close;
  }

  /* ---------- SF weather (SoMa) ---------- */
  if(liveWxEl){
    var wxIcons = {0:'\u2600\ufe0f',1:'\ud83c\udf24\ufe0f',2:'\u26c5',3:'\u2601\ufe0f',45:'\ud83c\udf2b\ufe0f',48:'\ud83c\udf2b\ufe0f',
      51:'\ud83c\udf26\ufe0f',53:'\ud83c\udf26\ufe0f',55:'\ud83c\udf27\ufe0f',61:'\ud83c\udf27\ufe0f',63:'\ud83c\udf27\ufe0f',65:'\ud83c\udf27\ufe0f',
      71:'\ud83c\udf28\ufe0f',73:'\ud83c\udf28\ufe0f',75:'\ud83c\udf28\ufe0f',80:'\ud83c\udf26\ufe0f',81:'\u26c8\ufe0f',82:'\u26c8\ufe0f',95:'\u26c8\ufe0f'};
    function fetchWx(attempt){
      fetch('https://api.open-meteo.com/v1/forecast?latitude=37.77&longitude=-122.41&current=temperature_2m,weather_code&temperature_unit=fahrenheit&timezone=America%2FLos_Angeles', { cache:'no-store' })
        .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('bad response')); })
        .then(function(data){
          var cur = data && data.current;
          if(!cur || typeof cur.temperature_2m !== 'number') return Promise.reject(new Error('no data'));
          var temp = Math.round(cur.temperature_2m);
          var icon = wxIcons[cur.weather_code] || '\ud83c\udf2b\ufe0f';
          var isFoggy = cur.weather_code === 45 || cur.weather_code === 48;
          liveWxEl.innerHTML = '<span class="wr-live-wx-icon">' + icon + '</span><span class="wr-live-temp">' + temp + '\u00b0F</span><span>' + (isFoggy ? 'Karl\u2019s out \u00b7 SoMa, live' : 'in SoMa, live') + '</span>';
        })
        .catch(function(){
          if(attempt < 2){ setTimeout(function(){ fetchWx(attempt + 1); }, 4000); }
          else if(liveWxEl.textContent.indexOf('Checking') === 0){ liveWxEl.textContent = 'Live SF weather is warming up \u2014 check back in a moment.'; }
        });
    }
    fetchWx(0);
    setInterval(function(){ fetchWx(0); }, 10 * 60 * 1000);
  }

  /* ---------- Next-slot urgency (slot bar + live card + booking line) ---------- */
  var slotTextEl = document.getElementById('wr-slotbar-text');
  var slotCountWrap = document.getElementById('wr-slotbar-count');
  var slotTimerEl = document.getElementById('wr-slotbar-timer');
  var slotClaimEl = document.getElementById('wr-slotbar-claim');
  var slotCardTime = document.getElementById('wr-live-slot-time');
  var slotCardSub = document.getElementById('wr-live-slot-sub');
  var slotCardDot = document.getElementById('wr-live-slot-dot');
  var bookSlotLine = document.getElementById('wr-book-slotline');

  function computeSlot(){
    var h = sfHoursToday();
    var p = ptParts();
    var nowMins = p.hour * 60 + p.minute;
    var lastSlot = h.close - 60; // last bookable bench slot: 1 hour before close
    var open = nowMins >= h.open && nowMins < h.close;

    var slotMins, isToday = true, nextDay = 'Tomorrow';
    var wd = ptWeekday();
    if(wd === 'Sun'){ isToday = false; slotMins = h.open; nextDay = 'Monday'; }
    else if(nowMins < h.open){
      slotMins = h.open; // before opening: first slot at open
    } else {
      // next slot is current SF time + 15 minutes
      slotMins = nowMins + 15;
      if(slotMins > lastSlot){ isToday = false; slotMins = h.open; if(wd === 'Sat') nextDay = 'Monday'; }
    }
    var slotsLeft = isToday ? Math.max(1, Math.floor((lastSlot - slotMins) / 15) + 1) : Math.floor((lastSlot - h.open) / 15) + 1;
    return { open:open, slotMins:slotMins, isToday:isToday, slotsLeft:Math.min(slotsLeft, 6), label:(isToday ? 'Today ' : nextDay + ' ') + fmt12(slotMins) + ' PT' };
  }

  var holdSeconds = 600; // 10-minute courtesy hold countdown
  function renderSlot(){
    var s = computeSlot();
    window.__wrNextSlotText = s.label;
    if(slotTextEl){
      slotTextEl.innerHTML = s.isToday
        ? 'Next open repair slot: <b>' + s.label + '</b> \u00b7 walk-ins welcome too'
        : 'We\u2019re closed right now. First open slot: <b>' + s.label + '</b>. Book it now and skip the line.';
    }
    if(slotClaimEl) slotClaimEl.textContent = s.isToday ? 'Book This Slot' : 'Book the First Slot';
    if(slotCardTime) slotCardTime.textContent = s.label;
    if(slotCardSub) slotCardSub.textContent = s.isToday
      ? 'Slots every 15 minutes \u00b7 walk-ins welcome too'
      : 'Doors open at ' + fmt12(sfHoursToday().open) + ' PT \u00b7 Mon\u2013Sat \u00b7 walk-ins welcome';
    if(slotCardDot) slotCardDot.classList.toggle('wr-live-dot-off', !s.isToday);
    if(bookSlotLine) bookSlotLine.textContent = s.isToday
      ? 'Next open repair slot: ' + s.label + '. Pick it below and it\u2019s yours.'
      : 'First open slot: ' + s.label + '. Book now and skip the morning line.';
  }
  renderSlot();
  setInterval(renderSlot, 60 * 1000);


  /* ---------- Open/closed card in the live grid ---------- */
  var liveOpenText = document.getElementById('wr-live-open-text');
  var liveOpenDot = document.getElementById('wr-live-open-dot');
  if(liveOpenText){
    var openNowCard = isStoreOpenNow();
    liveOpenText.textContent = openNowCard ? ('Open now \u00b7 till ' + fmt12(sfHoursToday().close) + ' PT') : (isSundayPT() ? 'Closed today \u00b7 opens Monday 10 AM' : 'Closed now');
    if(liveOpenDot) liveOpenDot.classList.toggle('wr-live-dot-off', !openNowCard);
  }

  /* ---------- Open/closed status on the SF location card ---------- */
  var locCard = document.getElementById('loc-sf');
  if(locCard){
    var statusEl = locCard.querySelector('.wr-loc-status');
    if(statusEl){
      var openNow = isStoreOpenNow();
      statusEl.textContent = openNow ? 'Open now' : 'Closed now';
      statusEl.classList.add(openNow ? 'wr-open' : 'wr-closed');
    }
  }

  /* ---------- Ride-type click-to-filter brands ---------- */
  var rideButtons = root.querySelectorAll('.wr-ride');
  var brandChips = root.querySelectorAll('#wr-brands-track .wr-brand');
  var rideNoteEl = document.getElementById('wr-ride-note');
  var defaultRideNote = rideNoteEl ? rideNoteEl.textContent : '';
  var activeRide = null;

  function applyRideFilter(btn){
    var list = (btn.dataset.brands || '').split(',').map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean);
    brandChips.forEach(function(chip){
      var name = chip.textContent.trim().toLowerCase();
      chip.classList.remove('wr-brand-dim','wr-brand-hl');
      if(!list.length) return;
      if(list.indexOf(name) > -1){ chip.classList.add('wr-brand-hl'); }
      else { chip.classList.add('wr-brand-dim'); }
    });
    if(rideNoteEl) rideNoteEl.textContent = btn.dataset.note || defaultRideNote;
  }
  function resetRideFilter(){
    brandChips.forEach(function(chip){ chip.classList.remove('wr-brand-dim','wr-brand-hl'); });
    if(rideNoteEl) rideNoteEl.textContent = defaultRideNote;
  }
  rideButtons.forEach(function(btn){
    btn.addEventListener('click', function(){
      if(activeRide === btn){
        activeRide = null;
        btn.classList.remove('wr-ride-active');
        resetRideFilter();
        return;
      }
      rideButtons.forEach(function(b){ b.classList.remove('wr-ride-active'); });
      btn.classList.add('wr-ride-active');
      activeRide = btn;
      applyRideFilter(btn);
    });
  });

  /* ---------- Repair guide tabs ---------- */
  var guideRoot = document.getElementById('wr-guide');
  if(guideRoot){
    var guideTabs = guideRoot.querySelectorAll('.wr-guide-tab');
    var guidePanels = guideRoot.querySelectorAll('.wr-guide-panel');
    guideRoot.classList.add('wr-guide-ready');

    function activateGuide(key){
      guideTabs.forEach(function(t){
        var on = t.dataset.guide === key;
        t.classList.toggle('wr-guide-tab-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      guidePanels.forEach(function(p){
        p.classList.toggle('wr-guide-panel-active', p.dataset.guidePanel === key);
      });
    }
    guideTabs.forEach(function(tab, i){
      tab.addEventListener('click', function(){ activateGuide(tab.dataset.guide); });
      tab.addEventListener('keydown', function(e){
        if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        var next = guideTabs[(i + dir + guideTabs.length) % guideTabs.length];
        next.focus();
        activateGuide(next.dataset.guide);
      });
    });
  }

  /* ---------- Reviews: carousel + live ticker + star pop ---------- */
  (function(){
    var track = document.getElementById('wr-rev-track');
    if(!track) return;
    var allCards = Array.prototype.slice.call(track.querySelectorAll('.wr-rev'));
    var dotsWrap = document.getElementById('wr-rev-dots');
    var prevBtn = document.getElementById('wr-rev-prev');
    var nextBtn = document.getElementById('wr-rev-next');
    var autoplayTimer = null;

    function scrollToCard(i){
      var card = allCards[i];
      if(!card) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function buildDots(){
      dotsWrap.innerHTML = '';
      allCards.forEach(function(c, i){
        var dd = document.createElement('button');
        dd.type = 'button';
        dd.className = 'wr-rev-dot' + (i === 0 ? ' wr-rev-dot-active' : '');
        dd.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dd.addEventListener('click', function(){ scrollToCard(i); resetAutoplay(); });
        dotsWrap.appendChild(dd);
      });
    }
    function currentIndex(){
      var idx = 0, best = Infinity;
      allCards.forEach(function(c, i){
        var dist = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
        if(dist < best){ best = dist; idx = i; }
      });
      return idx;
    }
    var swipeHintEl = document.getElementById('wr-rev-swipehint');
    function updateDots(){
      var idx = currentIndex();
      dotsWrap.querySelectorAll('.wr-rev-dot').forEach(function(dd, i){
        dd.classList.toggle('wr-rev-dot-active', i === idx);
      });
      allCards.forEach(function(c, i){
        c.classList.toggle('wr-rev-active', i === idx);
      });
      if(swipeHintEl) swipeHintEl.classList.add('wr-rev-swipehint-hide');
    }
    var scrollTick;
    track.addEventListener('scroll', function(){
      window.clearTimeout(scrollTick);
      scrollTick = setTimeout(updateDots, 90);
    });
    function stepRev(dir){
      var idx = currentIndex() + dir;
      if(idx < 0) idx = allCards.length - 1;
      if(idx >= allCards.length) idx = 0;
      scrollToCard(idx);
    }
    if(prevBtn) prevBtn.addEventListener('click', function(){ stepRev(-1); resetAutoplay(); });
    if(nextBtn) nextBtn.addEventListener('click', function(){ stepRev(1); resetAutoplay(); });
    function startAutoplay(){ if(reduce) return; autoplayTimer = setInterval(function(){ stepRev(1); }, 5000); }
    function stopAutoplay(){ clearInterval(autoplayTimer); }
    function resetAutoplay(){ stopAutoplay(); startAutoplay(); }
    track.addEventListener('pointerenter', stopAutoplay);
    track.addEventListener('pointerleave', startAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive:true });
    track.addEventListener('touchstart', function(){ if(swipeHintEl) swipeHintEl.classList.add('wr-rev-swipehint-hide'); }, { passive:true });
    buildDots();
    updateDots();
    startAutoplay();

    /* Animated star pop-in on the Google score */
    var starsEl = document.getElementById('wr-google-stars');
    if(starsEl){
      var chars = starsEl.textContent.trim().split('');
      starsEl.innerHTML = chars.map(function(ch){ return '<span>' + ch + '</span>'; }).join('');
      if('IntersectionObserver' in window){
        var sio = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(en.isIntersecting){ starsEl.classList.add('wr-stars-in'); sio.unobserve(en.target); }
          });
        }, { threshold:.6 });
        sio.observe(starsEl);
      } else { starsEl.classList.add('wr-stars-in'); }
    }

    /* Live-feeling ticker cycling through the SF review tags */
    var tickerEl = document.getElementById('wr-rev-ticker');
    if(tickerEl){
      var messages = allCards.map(function(c){
        var tagEl = c.querySelector('.wr-fixed-tag');
        var tag = tagEl ? tagEl.textContent.replace('Fixed: ', '') : 'a repair';
        return '<b>5-star Google review</b> \u2014 ' + tag + ' \u00b7 Wilson\u2019s San Francisco';
      });
      var mi = 0;
      function showMsg(){
        tickerEl.classList.add('wr-ticker-swap');
        setTimeout(function(){
          tickerEl.innerHTML = messages[mi % messages.length];
          tickerEl.classList.remove('wr-ticker-swap');
          mi++;
        }, reduce ? 0 : 220);
      }
      showMsg();
      if(!reduce) setInterval(showMsg, 4200);
    }
  })();

  /* ---------- FAQ search + category filter ---------- */
  var faqList = document.getElementById('wr-faq-list');
  if(faqList){
    var faqItems = faqList.querySelectorAll('details');
    var faqChips = root.querySelectorAll('.wr-faq-chip');
    var faqSearch = document.getElementById('wr-faq-search');
    var faqCountEl = document.getElementById('wr-faq-count');
    var faqEmptyEl = document.getElementById('wr-faq-empty');
    var activeCat = 'all';

    function faqApply(){
      var q = (faqSearch && faqSearch.value || '').trim().toLowerCase();
      var shown = 0;
      faqItems.forEach(function(item){
        var matchesCat = activeCat === 'all' || item.dataset.cat === activeCat;
        var text = item.textContent.toLowerCase();
        var matchesQuery = !q || text.indexOf(q) > -1;
        var visible = matchesCat && matchesQuery;
        item.classList.toggle('wr-faq-hide', !visible);
        if(visible) shown++;
      });
      if(faqCountEl) faqCountEl.textContent = shown + (shown === 1 ? ' question' : ' questions') + (activeCat !== 'all' || q ? ' match' + (shown===1?'es':'') : ' shown');
      if(faqEmptyEl) faqEmptyEl.hidden = shown !== 0;
    }
    faqChips.forEach(function(chip){
      chip.addEventListener('click', function(){
        faqChips.forEach(function(c){ c.classList.remove('wr-faq-chip-active'); });
        chip.classList.add('wr-faq-chip-active');
        activeCat = chip.dataset.cat;
        faqApply();
      });
    });
    if(faqSearch) faqSearch.addEventListener('input', faqApply);
    faqApply();
  }

})();
